
import { useState, useEffect } from 'react';

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-2xl md:text-3xl font-black tracking-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-100 to-amber-200">GUEPARDO</span>
              <span className="text-white ml-2">AGENCIA</span>
            </h1>
          </div>

          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Home</button>
            <button onClick={() => scrollToSection('sobre')} className="text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Sobre Nós</button>
            <button onClick={() => scrollToSection('servicos')} className="text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Serviços</button>
            <button onClick={() => scrollToSection('clientes')} className="text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Clientes</button>
            <button onClick={() => scrollToSection('depoimentos')} className="text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Depoimentos</button>
            <button onClick={() => scrollToSection('contato')} className="text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Contato</button>
          </nav>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Home</button>
            <button onClick={() => scrollToSection('sobre')} className="block text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Sobre Nós</button>
            <button onClick={() => scrollToSection('servicos')} className="block text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Serviços</button>
            <button onClick={() => scrollToSection('clientes')} className="block text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Clientes</button>
            <button onClick={() => scrollToSection('depoimentos')} className="block text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Depoimentos</button>
            <button onClick={() => scrollToSection('contato')} className="block text-white hover:text-amber-200 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Contato</button>
          </nav>
        )}
      </div>
    </header>
  );
}
